//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import JusticeIsBlindInfo from './justice-is-blind-info'

export default {
    computed: mapGetters({
        game: 'game',
        invasions: 'activeInvasions',
    }),

    methods: {
        openJibInfo() {
            this.$present(JusticeIsBlindInfo)
        },
    },
}
